import { render, staticRenderFns } from "./NsMinimalHeaderMiniCart.vue?vue&type=template&id=7a99cb71&scoped=true&"
import script from "./NsMinimalHeaderMiniCart.vue?vue&type=script&lang=js&"
export * from "./NsMinimalHeaderMiniCart.vue?vue&type=script&lang=js&"
import style0 from "./NsMinimalHeaderMiniCart.vue?vue&type=style&index=0&id=7a99cb71&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a99cb71",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a99cb71')) {
      api.createRecord('7a99cb71', component.options)
    } else {
      api.reload('7a99cb71', component.options)
    }
    module.hot.accept("./NsMinimalHeaderMiniCart.vue?vue&type=template&id=7a99cb71&scoped=true&", function () {
      api.rerender('7a99cb71', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/app-components/components/MinimalHeader/NsMinimalHeaderMiniCart.vue"
export default component.exports